var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10027 2.03437C4.67072 0.80532 6.58373 0.25 8 0.25C8.41421 0.25 8.75 0.585786 8.75 1C8.75 1.41421 8.41421 1.75 8 1.75C6.91627 1.75 5.32928 2.19468 4.02473 3.21563C2.74714 4.21548 1.75 5.75691 1.75 8C1.75 11.9864 5.30724 14.25 8 14.25C10.3597 14.25 12.9115 12.8938 13.7885 10.2628C13.9195 9.86987 14.3442 9.6575 14.7372 9.78849C15.1301 9.91947 15.3425 10.3442 15.2115 10.7372C14.0885 14.1062 10.8623 15.75 8 15.75C4.69276 15.75 0.25 13.0136 0.25 8C0.25 5.24309 1.50286 3.28452 3.10027 2.03437Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.fb6be6f2703b6434e9a41be7a6651557.svg";
export { ForwardRef as ReactComponent };